import { BusinessDetail } from "@/features/portal/components/financials/business/business-detail";

/** `/portal/financials/business/:businessId` — one business's 433-B sub-collections. */
export default function BusinessDetailPage() {
  return <BusinessDetail />;
}
